import { render, staticRenderFns } from "./ProfileInteraction.vue?vue&type=template&id=e046c82a"
import script from "./ProfileInteraction.vue?vue&type=script&lang=js"
export * from "./ProfileInteraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports